import { h } from 'vue';
import { RouterLink } from 'vue-router';
import _get from 'lodash/get';
import type { BuiTblColumn } from '@/components/bui/organisms/Tbl/types';
import TblRowActions from '@/components/bui/molecules/TblRowActions/TblRowActions.vue';
import TimeFormatDateOnly from '@/components/ListingPages/ItemsLister/ItemsList/FieldsRenderers/TimeFormatDateOnly.vue';

const usersColumns: BuiTblColumn[] = [
  {
    key: 'username',
    kind: 'name',
    label: 'Username',
    headerTestId: 'users-username-header',
    grow: true,
    minWidth: 180,
    selectable: true,
    sortable: true,
    sortKey: 'username',
    render: ({ item }) =>
      h(
        RouterLink,
        { to: `/users/edit/${item.id}`, class: 'title-link', 'data-testid': 'list-row-title', onClick: (e: MouseEvent) => e.stopPropagation() },
        () => item.username,
      ),
  },
  {
    key: 'firstName',
    kind: 'text',
    label: 'First Name',
    grow: true,
    minWidth: 120,
    sortable: true,
    sortKey: 'firstName',
    render: ({ item }) => item.firstName || '',
  },
  {
    key: 'lastName',
    kind: 'text',
    label: 'Last Name',
    grow: true,
    minWidth: 120,
    sortable: true,
    sortKey: 'lastName',
    render: ({ item }) => item.lastName || '',
  },
  {
    key: 'organization',
    kind: 'text',
    label: 'Organization',
    grow: true,
    minWidth: 140,
    render: ({ item }) => _get(item, 'group.name', 'None'),
  },
  {
    key: 'created',
    kind: 'text',
    label: 'Created',
    grow: true,
    minWidth: 110,
    sortable: true,
    sortKey: 'dateCreated',
    render: ({ item }) => h(TimeFormatDateOnly, { epochTime: item.dateCreated }),
  },
  {
    key: 'actions',
    kind: 'actions',
    label: 'Actions',
    width: 100,
    render: ({ item }) => h(TblRowActions, { item }),
  },
];

export default usersColumns;
